export const menuItems = [
  {
    key: "rise-os",
    label: "Rise OS",
    children: [
      {
        key: "/dashboard",
        label: "Dashboard",
      },
      {
        key: "/package",
        label: "Package",
      },
      {
        key: "/category",
        label: "Category",
      },
      {
        key: "/subcategory",
        label: "Sub Category",
      },
      {
        key: "/policy",
        label: "Policy",
      },
      {
        key: "/legislation-link",
        label: "Legislation Link",
      },
      {
        key: "/form",
        label: "Form",
      },
      {
        key: "/user",
        label: "User",
      },
      {
        key: "/auditor",
        label: "Auditor",
      },
      {
        key: "/registration-group",
        label: "Registration Group",
      },
      {
        key: "/onboarding-step",
        label: "Onboarding Step",
      },
      {
        key: "/user-onboarding-progress",
        label: "User Onboarding Progress",
      },
      {
        key: "/tag",
        label: "Tag",
      },
      {
        key: "/notification",
        label: "Notification",
      },
      {
        key: "/tickets",
        label: "Tickets",
      },
    ],
  },
];

export const getActiveRoute = (key: string) => {
  switch (key) {
    // Dashboard
    case "/dashboard":
      return ["rise-os", "/dashboard"];

    // Package
    case "/package":
    case "/package/create":
    case "/package/edit":
    case "/package/show":
      return ["rise-os", "/package"];

    // Category
    case "/category":
    case "/category/create":
    case "/category/edit":
    case "/category/show":
      return ["rise-os", "/category"];

    // Subcategory
    case "/subcategory":
    case "/subcategory/create":
    case "/subcategory/edit":
    case "/subcategory/show":
      return ["rise-os", "/subcategory"];

    // Policy
    case "/policy":
    case "/policy/create":
    case "/policy/edit":
    case "/policy/show":
      return ["rise-os", "/policy"];

    // Legislation
    case "/legislation-link":
    case "/legislation-link/create":
    case "/legislation-link/edit":
    case "/legislation-link/show":
      return ["rise-os", "/legislation-link"];

    // Form
    case "/form":
      return ["rise-os", "/form"];

    // User
    case "/user":
    case "/user/create":
    case "/user/edit":
    case "/user/show":
      return ["rise-os", "/user"];

    // Auditor
    case "/auditor":
    case "/auditor/create":
    case "/auditor/edit":
    case "/auditor/show":
      return ["rise-os", "/auditor"];

    // Registration Group
    case "/registration-group":
    case "/registration-group/create":
    case "/registration-group/edit":
    case "/registration-group/show":
      return ["rise-os", "/registration-group"];

    // Onboarding Step
    case "/onboarding-step":
    case "/onboarding-step/create":
    case "/onboarding-step/edit":
    case "/onboarding-step/show":
      return ["rise-os", "/onboarding-step"];

    // User Onboarding Progress
    case "/user-onboarding-progress":
    case "/user-onboarding-progress/create":
    case "/user-onboarding-progress/edit":
    case "/user-onboarding-progress/show":
      return ["rise-os", "/user-onboarding-progress"];

    // Tag
    case "/tag":
    case "/tag/create":
    case "/tag/edit":
    case "/tag/show":
      return ["rise-os", "/tag"];

    // Notification
    case "/notification":
    case "/notification/create":
    case "/notification/edit":
    case "/notification/show":
      return ["rise-os", "/notification"];

    // Tickets
    case "/tickets":
      return ["rise-os", "/tickets"];

    // Default
    default:
      return ["rise-os", "/dashboard"];
  }
};
